import { Icon, Row, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
const CustomButton = styled.button`
  height: 54px;
  width: 153px;
  border-radius: 40px;
  padding: 0 24px;

  &:hover {
    opacity: 0.5;
  }

  &:disabled {
    opacity: 0.5;
  }

  &:active {
    opacity: 1;
    color: ${theme.DARK_PURPLE};

    div > svg > path {
      fill: ${theme.DARK_PURPLE};
    }
  }
`;

const UploadButton = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <CustomButton onClick={onClick && onClick}>
      <Row center>
        <Icon type="upload" marg="0 14px 0 0" dimensions={16} />

        <Text bold size="20px">
          {t('common.upload')}
        </Text>
      </Row>
    </CustomButton>
  );
};

export default UploadButton;
